import axios, { AxiosRequestConfig } from 'axios';
import { DataResponse, PagedResponse } from '../types';
import { ParentReviewFaq } from '../types/ParentReviewFaq';

const URL = '/v2/parent-review-faq';

class ParentReviewFaqService {
  static getByFilter(config?: AxiosRequestConfig): Promise<PagedResponse<ParentReviewFaq>> {
    return axios.get(URL, config);
  }

  static create(
    data: ParentReviewFaq,
    config?: AxiosRequestConfig
  ): Promise<DataResponse<ParentReviewFaq>> {
    return axios.post(URL, data, config);
  }
}

export { ParentReviewFaqService };
